import { render, staticRenderFns } from "./edit-inbox.vue?vue&type=template&id=2b8469f7&scoped=true&"
import script from "./edit-inbox.vue?vue&type=script&lang=js&"
export * from "./edit-inbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8469f7",
  null
  
)

export default component.exports